<template>
  <div ref="swiper" class="swiper-container">
    <div class="swiper-wrapper"
         :class="{isDragging}"
         :style="{left: slidePosition}"
         ref="slides"
         @mousedown="onHandleStart"
         @touchstart="onHandleStart"
    >
      <div class="list1 swiper-slide" ref="swiperSlide" :class="{ active: currentIndex === 0, [$i18n.locale]: true }">
        <div class="swiper-content--wrap">
          <div class="swiper-title--wrap">
            <div class="swiper-title">
              <span class="title">{{ $t('page.registration.guide.step1.exact.title') }}</span>
              <span class="sub-title" v-html="$t('page.registration.guide.step1.exact.subTitle')"></span>
            </div>
            <div class="swiper-url--wrap ">
              <span class="url" :class="$i18n.locale">
                <span class="yellow-bg">http</span>://<span class="blue-bg">www</span>.<span class="yellow-bg">beusable.net</span>/<span class="blue-bg">pages</span>/<span class="yellow-bg">?x=1&ux=text</span><span class="blue-bg">#article</span>
                <span class="properties protocol">Protocol</span>
                <span class="properties sub-domain">Sub Domain</span>
                <span class="properties main-domain">Main Domain</span>
                <span class="properties path">Path</span>
                <span class="properties parameter">Parameter</span>
                <span class="properties fragment">Fragment</span>
              </span>
            </div>
          </div>
          <div class="desc--wrap">
            <p class="title">{{ $t('page.registration.guide.title') }}</p>
            <ul>
              <li class="desc" v-html="$t('page.registration.guide.step1.exact.desc[0]')"></li>
              <li class="desc" v-html="$t('page.registration.guide.step1.exact.desc[1]')"></li>
            </ul>
            <a class="match-select-guide" :href="matchGuideLink" target="_blank" v-html="$t('page.registration.guide.matchGuide')"></a>
          </div>
        </div>
      </div>
      <div class="list2 swiper-slide" ref="swiperSlide" :class="{ active: currentIndex === 1, [$i18n.locale]: true }">
        <div class="swiper-content--wrap">
          <div class="swiper-title--wrap">
            <div class="swiper-title">
              <span class="title">{{ $t('page.registration.guide.step1.simple.title') }}</span>
              <span class="sub-title" v-html="$t('page.registration.guide.step1.simple.subTitle')"></span>
            </div>
            <div class="swiper-url--wrap simple">
              <span class="url" :class="$i18n.locale">
                <span class="yellow-bg">http</span>://<span class="blue-bg">www</span>.<span class="box"><span class="yellow-bg">beusable.net</span>/<span class="blue-bg">pages</span></span>/<span class="yellow-bg">?x=1&ux=text</span><span class="blue-bg">#article</span>
                <span class="properties protocol">Protocol</span>
                <span class="properties sub-domain">Sub Domain</span>
                <span class="properties main-domain">Main Domain</span>
                <span class="properties path">Path</span>
                <span class="properties parameter">Parameter</span>
                <span class="properties fragment">Fragment</span>
              </span>
            </div>
          </div>
          <div class="desc--wrap">
            <p class="title">{{ $t('page.registration.guide.title') }}</p>
            <ul>
              <li class="desc" v-html="$t('page.registration.guide.step1.simple.desc[0]')"></li>
              <li class="desc" v-html="$t('page.registration.guide.step1.simple.desc[1]')"></li>
            </ul>
            <a class="match-select-guide" :href="matchGuideLink" target="_blank" v-html="$t('page.registration.guide.matchGuide')"></a>
          </div>
        </div>
      </div>

      <div class="list3 swiper-slide" ref="swiperSlide" :class="{ active: currentIndex === 2, [$i18n.locale]: true }">
        <div class="swiper-content--wrap">
          <div class="swiper-title--wrap starts">
            <div class="swiper-title">
              <span class="title">{{ $t('page.registration.guide.step1.starts.title') }}</span>
              <span class="sub-title" :class="$i18n.locale" v-html="$t('page.registration.guide.step1.starts.subTitle')"></span>
            </div>
            <div class="swiper-input--wrap" :class="$i18n.locale">
              <div class="inputs">
                <input type="text" value="http://www.beusable.net/pages" disabled/>
              </div>
              <span>{{ $t('page.registration.guide.step1.starts.input') }}</span>
            </div>
            <div class="swiper-url--wrap starts-reg" :class="$i18n.locale">
              <span class="url">
                <span class="red-bg">http://www.beusable.net/pages</span>12345
              </span>
              <span class="url">
                 <span class="red-bg">http://www.beusable.net/pages</span>/report/
              </span>
              <span class="url">
                 <span class="red-bg">http://www.beusable.net/pages</span>/?x=1&ux=text#article
              </span>
            </div>
          </div>
          <div class="desc--wrap">
            <p class="title">{{ $t('page.registration.guide.title') }}</p>
            <ul>
              <li class="desc" v-html="$t('page.registration.guide.step1.starts.desc[0]')"></li>
            </ul>
            <a class="match-select-guide" :href="matchGuideLink" target="_blank" v-html="$t('page.registration.guide.matchGuide')"></a>
          </div>
        </div>
      </div>
      <div class="list4 swiper-slide" ref="swiperSlide" :class="{ active: currentIndex === 3, [$i18n.locale]: true }">
        <div class="swiper-content--wrap">
          <div class="swiper-title--wrap ends">
            <div class="swiper-title">
              <span class="title">{{ $t('page.registration.guide.step1.ends.title') }}</span>
              <span class="sub-title" :class="$i18n.locale" v-html="$t('page.registration.guide.step1.ends.subTitle')"></span>
            </div>
            <div class="swiper-input--wrap" :class="$i18n.locale">
              <div class="inputs">
                <input class="domain-input" type="text" value="http://www.beusable.net" disabled/>
                <input class="text-input" type="text" value="#article" disabled/>
                <span class="domain">Domain</span>
                <span class="text">End Text</span>
              </div>
              <span>{{ $t('page.registration.guide.step1.ends.input') }}</span>
            </div>
            <div class="swiper-url--wrap starts-reg" :class="$i18n.locale">
              <span class="url">
                http://<span class="red-bg article">www.beusable.net</span>/pages/?x=1&ux=text<span class="red-bg article">#article</span>
              </span>
            </div>
          </div>
          <div class="desc--wrap">
            <p class="title">{{ $t('page.registration.guide.title') }}</p>
            <ul>
              <li class="desc" v-html="$t('page.registration.guide.step1.ends.desc[0]')"></li>
            </ul>
            <a class="match-select-guide" :href="matchGuideLink" target="_blank" v-html="$t('page.registration.guide.matchGuide')"></a>
          </div>
        </div>
      </div>
      <div class="list5 swiper-slide" ref="swiperSlide" :class="{ active: currentIndex === 4, [$i18n.locale]: true }">
        <div class="swiper-content--wrap">
          <div class="swiper-title--wrap ends">
            <div class="swiper-title">
              <span class="title">{{ $t('page.registration.guide.step1.contains.title') }}</span>
              <span class="sub-title" :class="$i18n.locale" v-html="$t('page.registration.guide.step1.contains.subTitle')"></span>
            </div>
            <div class="swiper-input--wrap" :class="$i18n.locale">
              <div class="inputs">
                <input class="domain-input" type="text" value="http://www.beusable.net" disabled/>
                <input class="contains-input" type="text" value="?x=1" disabled/>
                <span class="domain">Domain</span>
                <span class="text contains">Contains Text</span>
              </div>
              <span>{{ $t('page.registration.guide.step1.contains.input') }}</span>
            </div>
            <div class="swiper-url--wrap starts-reg" :class="$i18n.locale">
              <span class="url">
                http://<span class="red-bg article">www.beusable.net</span>/pages/<span class="red-bg article">?x=1</span>&ux=text#article
              </span>
              <span class="url">
                http://<span class="red-bg article">www.beusable.net</span>/pages/<span class="red-bg article">?x=1</span>23456
              </span>
            </div>
          </div>
          <div class="desc--wrap">
            <p class="title">{{ $t('page.registration.guide.title') }}</p>
            <ul>
              <li class="desc" v-html="$t('page.registration.guide.step1.contains.desc[0]')"></li>
            </ul>
            <a class="match-select-guide" :href="matchGuideLink" target="_blank" v-html="$t('page.registration.guide.matchGuide')"></a>
          </div>
        </div>
      </div>
      <div class="list6 swiper-slide" ref="swiperSlide" :class="{ active: currentIndex === 5, [$i18n.locale]: true }">
        <div class="swiper-content--wrap">
          <div class="swiper-title--wrap ends regExp">
            <div class="swiper-title">
              <span class="title">{{ $t('page.registration.guide.step1.regExp.title') }}</span>
              <span class="sub-title" :class="$i18n.locale" v-html="$t('page.registration.guide.step1.regExp.subTitle')"></span>
            </div>
            <div class="swiper-input--wrap reg" :class="$i18n.locale">
              <div class="inputs">
                <input class="domain-input" type="text" value="http://www.beusable.net" disabled/>
                <input class="reg-input" type="text" value="\/orders\/([0-9]+)\/items" disabled/>
                <span class="domain">Domain</span>
                <span class="text contains">Contains Text</span>
              </div>
              <span>{{ $t('page.registration.guide.step1.regExp.input') }}</span>
            </div>
            <div class="swiper-url--wrap starts-reg" :class="$i18n.locale">
              <span class="url">
                http://www.beusable.net/orders/5/items/13
              </span>
              <span class="url">
                http://www.beusable.net/orders/1/items/50473
              </span>
            </div>
          </div>
          <div class="desc--wrap">
            <p class="title">{{ $t('page.registration.guide.title') }}</p>
            <ul>
              <li class="desc" v-html="$t('page.registration.guide.step1.regExp.desc[0]')"></li>
            </ul>
            <a class="match-select-guide" :href="matchGuideLink" target="_blank" v-html="$t('page.registration.guide.matchGuide')"></a>
            <span class="tip" v-html="$t('page.registration.guide.step1.regExp.tip')">
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-pagination" slot="pagination" ref="pagination">
      <template v-for="index in slides.length">
        <span
          :key="index"
          class="dot"
          :class="{ active: index - 1 === currentIndex }"
          @click="goToSlide(index - 1)"
        ></span>
      </template>
    </div>
    <div v-show="!isFirstSlide"
         ref="swiperLeft"
         class="swiper-button-prev icon icon--prev-white-size20 step1"
         @click="prevSlide"
    ></div>
    <div v-show="!isLastSlide"
         ref="swiperRight"
         class="swiper-button-next icon icon--prev-white-size20 step1"
         @click="nextSlide"
    ></div>
  </div>
</template>

<script>

import { isFriday } from 'date-fns'

export default {
  props: [
    'focusContent',
    'slideCurrentIndex'
  ],
  data () {
    return {
      slides: [],
      currentIndex: this.slideCurrentIndex,
      isDragging: false,
      startX: 0,
      endX: 0,
      dragOffset: 0,
      slidePosition: null
    }
  },
  computed: {
    matchGuideLink () {
      switch (this.$i18n.locale) {
        case 'ko':
          return 'https://forum.beusable.net/ko/solomon/post/732'
        case 'en':
          return 'https://forum.beusable.net/en/solomon/post/1432'
        case 'ja':
          return 'https://forum.beusable.net/ja/solomon/post/2351'
        default:
          return null
      }
    },
    isFirstSlide () {
      return this.currentIndex === 0
    },
    isLastSlide () {
      if (this.slides) {
        return this.currentIndex === this.slides.length - 1
      }
      return false
    }
  },
  mounted () {
    this.slides = document.querySelectorAll('.swiper-slide')
    this.currentIndex = this.slideCurrentIndex

    if (this.$refs.pagination.children.length !== 0) {
      if (this.focusContent.currentContentIndex < 7) {
        this.$refs.pagination.children[this.focusContent.currentContentIndex].click()
      } else {
        this.$refs.pagination.children[this.slideCurrentIndex].click()
      }
    }
    this.getTransformStyle()
  },
  watch: {
    focusContent () {
      if (this.focusContent.currentStep === 2) {
        const contentIndex = this.focusContent.currentContentIndex
        if (contentIndex < 7) {
          this.$refs.pagination.children[contentIndex].click()
        } else {
          this.$refs.pagination.children[this.currentIndex].click()
        }
      }
    }
  },
  methods: {
    isFriday,
    nextSlide () {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length
      this.getTransformStyle()
    },
    prevSlide () {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length
      this.getTransformStyle()
    },
    goToSlide (index) {
      this.currentIndex = index
      this.getTransformStyle()
    },
    onHandleStart (event) {
      this.isDragging = true
      this.startX = event.touches ? event.touches[0].clientX : event.clientX
      this.dragOffset = 0
      if (this.isDragging) {
        window.addEventListener('mousemove', this.onHandleMove)
        window.addEventListener('mouseup', this.onHandleEnd)
      }
    },
    onHandleMove (event) {
      if (!this.isDragging) return

      const currentX = event.touches ? event.touches[0].clientX : event.clientX
      this.dragOffset = currentX - this.startX
      const dragTranslate = (this.dragOffset / 480) * 100
      const baseTranslate = -this.currentIndex * 100
      this.slidePosition = `${baseTranslate + dragTranslate}%`
    },
    onHandleEnd () {
      if (!this.isDragging) return

      if (this.dragOffset > 50) {
        this.prevSlide()
      } else if (this.dragOffset < -50) {
        this.nextSlide()
      } else {
        this.resetDrag()
      }
      this.isDragging = false
      this.startX = 0
      this.endX = 0
      this.getTransformStyle()
    },
    getTransformStyle () {
      const baseTranslate = -this.currentIndex * 100
      const dragTranslate = (this.endX / 480) * 100
      this.slidePosition = `${baseTranslate + dragTranslate}%`
    },
    resetDrag () {
      this.dragOffset = 0
    }
  }
}
</script>
